import Vue from 'vue'
import Router from 'vue-router'
import liveList from '@/components/liveList/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'liveList',
      component: liveList
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js